import type React from "react";
import Style from "./ContentWrapper.module.scss";

export const ContentWrapper: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
	return (
		<div className={Style.windowWrapper}>
			<div className={Style.window}>{children}</div>
		</div>
	);
};
